if (typeof wpcf7 !== 'undefined') {
  wpcf7.cached = 0;
}

var _km_consultados_set = new Set();
var _duracion_consultadas_set = new Set();

jQuery(document).ready(function ($) {

  //******  SCRIPT PRECIOS

  function format_as_euro(amount) {
    var numericAmount = parseFloat(amount);

    if (!isNaN(numericAmount)) {
      return numericAmount.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' €';
    } else {
      return false;
    }
  }

  //// controlar errores
  window.onerror = function (message, source, lineno, colno, error) {
    console.warn('Error detectado:', { message, source, lineno, colno, error });
    return false;
  };

  window.addEventListener('unhandledrejection', function (event) {
    event.preventDefault();
  });


  function actualizar_kmmeses(scope) {
    const compra_flexible = location.href.includes('compra-flexible');
    var $scope = scope ? jQuery(scope) : jQuery(document);

    $scope.find('.mesesvar').each(function () {
      var $form = jQuery(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var $mesesVar = $form.find('.mesesvar');
      var $kmVar = $form.find('.kmvar');

      var $idCampanaInput = $form.find('[id^="idcampana"], [name="idcampana"]');
      var localIdCampana = $idCampanaInput.val() || (typeof idcampana !== 'undefined' ? idcampana : '');

      if (localIdCampana && window["arr_km_" + localIdCampana]) {
        var currentKmVal = $kmVar.val();
        $kmVar.find('option').remove();
        $kmVar.append(window["arr_km_" + localIdCampana]);
        if (currentKmVal && $kmVar.find('option[value="' + currentKmVal + '"]').length > 0) {
          $kmVar.val(currentKmVal);
        }
      }

      const kmValue = $kmVar.val();
      if (localIdCampana && window["options_km_" + localIdCampana] && kmValue && window["options_km_" + localIdCampana][kmValue]) {
        var currentMesesVal = $mesesVar.val();
        $mesesVar.find('option').remove();
        $mesesVar.append(window["options_km_" + localIdCampana][kmValue]);
        if (currentMesesVal && $mesesVar.find('option[value="' + currentMesesVal + '"]').length > 0) {
          $mesesVar.val(currentMesesVal);
        }
      }

      try {
        const currentKm = $kmVar.val();
        const currentMeses = $mesesVar.val();
        const str = currentKm && currentMeses ? currentKm + '|' + currentMeses : null;

        if (str && localIdCampana) {
          if (compra_flexible == true && window["vfr_cp_" + localIdCampana] && window["vfr_cp_" + localIdCampana][str]) {
            var price = window["vfr_cp_" + localIdCampana][str];
            var formattedPrice = format_as_euro(price);
            $form.find('.item-price-final').html('<small class="text--grey">Cuota final ' + formattedPrice + ' o lo devuelves sin coste adicional </small>');
          }

          if (window["arr_tarifas_" + localIdCampana] && window["arr_tarifas_" + localIdCampana][str]) {
            var tarifa = window["arr_tarifas_" + localIdCampana][str];
            $form.find('p#item-price, p#item-price-down').html(tarifa + ' &#8364;');
            $form.find('.item-price-siniva').html((tarifa / 1.21).toFixed(0) + ' &#8364; <small>+ IVA</small>');
          }
        }
      } catch (error) {
        console.error("Error al actualizar precios:", error);
      }
    });
  }

  $(document).ready(function () {

    // Inicializar inputs idcolor con el valor global por defecto
    // (para cuando el usuario no hace clic en ningún color)
    if (typeof window.idcolor !== 'undefined' && window.idcolor) {
      $('[id^="idcolor"]').each(function () {
        if (!$(this).val()) {
          $(this).val(window.idcolor);
        }
      });
    }

    $('.checking li').click(function (e) {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var localIdCampana = $(this).data('idcampana') || $(this).attr('data-idcampana');
      var localIdColor = $(this).data('name') || $(this).attr('data-name');

      if (typeof localIdCampana !== 'undefined' && localIdCampana !== '') {
        $form.find('[id^="idcampana"], [name="idcampana"]').val(localIdCampana);
        const campanaInput = $form.find('[id^="idcampana"], [name="idcampana"]')[0];
        if (campanaInput) {
          campanaInput.dispatchEvent(new Event("change"));
        }
      }

      if (typeof localIdColor !== 'undefined' && localIdColor !== '') {
        $form.find('[id^="idcolor"], [name="idcolor"]').val(localIdColor);
        const colorInput = $form.find('[id^="idcolor"], [name="idcolor"]')[0];
        if (colorInput) {
          colorInput.dispatchEvent(new Event("change"));
        }
      }

      // Si el sitio usa el viejo actualizar_kmmeses(), llamarlo pasando el scope
      actualizar_kmmeses($form);
    });

    $(document).on('change', '.kmvar', function () {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      var $mesesVar = $form.find('.mesesvar');
      var previousmeses = $mesesVar.val();

      $mesesVar.find('option').remove();

      var kmValue = $(this).val();
      var $idCampanaInput = $form.find('[id^="idcampana"], [name="idcampana"]');
      var safeIdCampana = $idCampanaInput.val() || (typeof idcampana !== 'undefined' ? idcampana : '');
      if (safeIdCampana && window["options_km_" + safeIdCampana] && kmValue && window["options_km_" + safeIdCampana][kmValue]) {
        $mesesVar.append(window["options_km_" + safeIdCampana][kmValue]);
      }

      $mesesVar.find('option').each(function () {
        if ($(this).val() == previousmeses) {
          $(this).prop('selected', true);
        }
      });

      actualizar_precios_scope($form);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('kmvar') && e.target.value) {
        var kmValue = e.target.value;
        var scope = e.target.closest('.card-single, .combo, .card-detail, .wrapper-selects, .block--inputs') || document;
        var kmLabelEl = scope.querySelector('.custom-select[id^="select-km"] .custom-select__value');
        var kmLabel = kmLabelEl ? kmLabelEl.textContent.trim() : (kmValue + ' Km');
        _km_consultados_set.add(kmLabel);
      }
      if (e.target && e.target.classList.contains('mesesvar') && e.target.value) {
        var mesesValue = e.target.value;
        var scope = e.target.closest('.card-single, .combo, .card-detail, .wrapper-selects, .block--inputs') || document;
        var mesesLabelEl = scope.querySelector('.custom-select[id^="select-meses"] .custom-select__value');
        var mesesLabel = mesesLabelEl ? mesesLabelEl.textContent.trim() : (mesesValue + ' Meses');
        _duracion_consultadas_set.add(mesesLabel);
      }
    });

    $(document).on('change', '.mesesvar', function () {
      var $form = $(this).closest('.card-single, .combo, .card-detail, .wrapper-selects');
      actualizar_precios_scope($form);
    });

    function actualizar_precios_scope($form) {
      var $idCampanaInput = $form.find('[id^="idcampana"], [name="idcampana"]');
      const safeIdCampana = $idCampanaInput.val() || (typeof idcampana !== 'undefined' ? idcampana : '');
      const compra_flexible = location.href.includes('compra-flexible');
      const kmValue = $form.find('.kmvar').val();
      const mesesValue = $form.find('.mesesvar').val();
      const str = kmValue && mesesValue ? kmValue + '|' + mesesValue : null;

      if (str && safeIdCampana && window["arr_tarifas_" + safeIdCampana] && window["arr_tarifas_" + safeIdCampana][str]) {
        if (compra_flexible == true && window["vfr_cp_" + safeIdCampana] && window["vfr_cp_" + safeIdCampana][str]) {
          var price = window["vfr_cp_" + safeIdCampana][str];
          var formattedPrice = format_as_euro(price);
          $form.find('.item-price-final').html('<small class="text--grey">Cuota final ' + formattedPrice + ' o lo devuelves sin coste adicional </small>');
        }

        var tarifa = window["arr_tarifas_" + safeIdCampana][str];
        $form.find('p#item-price, p#item-price-down').html(tarifa + ' &#8364;');
        $form.find('.item-price-siniva').html((tarifa / 1.21).toFixed(0) + ' &#8364; <small>+ IVA</small>');
      }
    }

    actualizar_kmmeses();

  });



  //******  BUTTON MOBILE

  $(window).scroll(function () {
    if ($(window).scrollTop() + $(window).height() > $(document).height() - 200) {
      $('#bottom-footer').addClass('is-fixed');
    } else {
      $('#bottom-footer').removeClass('is-fixed');
    }
  });

  //******  PERMITIR SOLO NUMEROS EN EL INPUT TELEFONO y AÑADIR BOTON CERRAR

  $(document).on('input', '.wpcf7-tel', function () {
    this.value = this.value.replace(/^[^6,7]*/, '');
    this.value = this.value.replace(/\D/g, '');
  });

  $(document).on('mailsent.wpcf7', function () {
    $('.close-send').addClass('visible');
  });


});



/*
document.addEventListener( 'wpcf7submit', function( event ) {
  
var inputs = event.detail.inputs;
var nombre = "";
var email = "";
var telefono ="";
var url_guardada ="";
for ( var i = 0; i < inputs.length; i++ ) {
  if ( 'your-name' == inputs[i].name ) {
     nombre = inputs[i].value;
  }
  if ( 'your-email' == inputs[i].name ) {
     email = inputs[i].value;
  }
  if ( 'telefono' == inputs[i].name ) {
     telefono = inputs[i].value;
  }  
  if ( 'url_guardada' == inputs[i].name ) {
     url_guardada = inputs[i].value;
  }
}

var precio = "";

if(jQuery('p#item-price').length>0){

var precio_html = jQuery('p#item-price').html();
//console.log("el precio html es "+precio_html);
var partes_precio = precio_html.split(" ");
var precio = partes_precio[0];

}

if(nombre!=""&&telefono!=""&&telefono!=""&&telefono.length==9&&email!=""&&validateEmail_cf(email)){

dataLayer.push({'event' : 'form-id-'+event.detail.contactFormId });
//alert("va a enviar "+email+" - "+url_guardada);
send2db(nombre,email,telefono,precio,url_guardada);

}


}, false );
*/


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//funcion para activar/desactivar el botón enviar del nuevo formulario
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function validaAvisoCheckbox(element_original, id) {
  //var botonEnviar = document.getElementById(id);
  var botonEnviar = document.getElementsByClassName(id);
  Array.from(botonEnviar).forEach(function (element, index, array) {
    if (element_original.checked == true) {
      //console.log("activar boton Envio");   
      element.disabled = false;
      //botonEnviar[1].disabled = false;
    } else {
      //console.log("desactivar boton Envio"); 
      element.disabled = true;
      //botonEnviar[1].disabled = true;
    }
  });


}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
//funcion prepararEnvioF : recoge los datos que antes se llevaban por ContactForm7 en base al id del form (url de la pagina en la que esté)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function validateForm(formId, fieldName) {
  const currentForm = document.querySelector("[data-id='" + formId + "']");
  let invalidFields = [];

  if (fieldName) { // When user do onBlur on a specific field
    validateFormFields(currentForm, fieldName);
  } else { // When user clcik on the submit button
    const requiredFields = [...currentForm.querySelectorAll("[data-required]")];
    // Parse all required fields and create an array with true/flase depending on the every field validation
    invalidFields = requiredFields.map((field) => validateFormFields(currentForm, field.name));
  }

  // If all fields are valid, send the form
  if (invalidFields.length > 0 && !invalidFields.some(field => field === false)) {
    prepararEnvioF(formId);
  }

}

const validateFormFields = (currentForm, fieldName) => {
  const field = currentForm.querySelector(`[name=${fieldName}]`);

  /* name */
  if (field.name === "your-name") {
    if (field.value.trim() === "") {
      return validateFormFieldsSetError(field, "Introduce tu nombre")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  /* email */
  if (field.name === "your-email") {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (field.value.trim() === "") {
      return validateFormFieldsSetError(field, "Introduce tu correo electrónico")
    } else if (!emailRegex.test(field.value.trim())) {
      return validateFormFieldsSetError(field, "Introduce un correo electrónico válido")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  /* phone */
  if (field.name === "telefono") {
    const phoneRegex = /^[+]?[\s./0-9()-]{7,15}$/;
    if (field.value.trim() === "") {
      return validateFormFieldsSetError(field, "Introduce tu teléfono de contacto")
    } else if (!phoneRegex.test(field.value.trim())) {
      return validateFormFieldsSetError(field, "Introduce un teléfono válido")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  /* textarea */
  if (field.name === "car-details") {
    if (field.value.trim() === "" || field.value.trim().length < 5) {
      return validateFormFieldsSetError(field, "Introduce el coche que estás buscando")
    } else {
      return validateFormFieldsClearError(field)
    }
  }

  /* checkbox */
  if (field.type === "checkbox") {
    if (!field.checked) {
      field.nextElementSibling.classList.add("required-form-error-before");
      return false;
    } else {
      field.nextElementSibling.classList.remove("required-form-error-before");
      return true;
    }
  }

}

const validateFormFieldsSetError = (field, msg) => {
  field.classList.add("required-form-error");
  field.nextElementSibling.innerHTML = msg;
  return false;
}

const validateFormFieldsClearError = (field) => {
  field.classList.remove("required-form-error");
  field.nextElementSibling.innerHTML = "";
  return true;
}

var filtro_cliente = "";

function checkTypeClient(form_envio) {
  form_envio.addEventListener('submit', function (event) {
    if (!filtro_cliente) {
      event.preventDefault();
      alert("Tipo de cliente requerido");
    }
  });
}

function prepararEnvioF(id) {
  var form_envio = document.querySelector("[data-id='" + id + "']");
  var inputElements = form_envio.querySelectorAll("input");
  var textareaElements = document.querySelectorAll("textarea[name='car-details']");

  var nombre = "";
  var email = "";
  var telefono = "";
  var url_guardada = "";
  var utm_source = "";
  var boletin = "0";
  var comentariosemail = "";
  filtro_cliente = "";

  for (let i = 0; i < inputElements.length; i++) {
    if (inputElements[i].name == "your-name") {
      nombre = inputElements[i].value;
    }
    if (inputElements[i].name == "your-email") {
      email = inputElements[i].value;
    }
    if (inputElements[i].name == "telefono") {
      telefono = inputElements[i].value;
    }
    if (inputElements[i].name == "url_guardada") {
      url_guardada = inputElements[i].value;
    }
    if (inputElements[i].name == "utm_source") {
      utm_source = inputElements[i].value;
    }
    if (inputElements[i].name == "boletin") {
      if (inputElements[i].checked) {
        boletin = "1";
      }
    }
    if (inputElements[i].name == "client-type" && inputElements[i].checked) {
      filtro_cliente = inputElements[i].value;
    }
  }

  for (let i = 0; i < textareaElements.length; i++) {
    comentariosemail = textareaElements[i].value;
  }

  var clientTypeContainer = form_envio.querySelector(".client-type-container");
  if (clientTypeContainer) {
    var radioButtons = clientTypeContainer.querySelectorAll("input[name='client-type']");
    if (radioButtons.length > 0) {
      checkTypeClient(form_envio);
    }
  }

  var telef = /^\d{9}$/;
  if (telef.test(telefono)) {
    console.log("valor correcto");
  } else {
    console.log("INTRODUCE OTRO VALOR. EJ: +34666555444");
    return false;
  }

  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(email)) {
    console.log("Correo electrónico válido");
  } else {
    console.log("Correo electrónico inválido");
    return false;
  }

  if (nombre == "") {
    console.log("Nombre inválido");
    return false;
  }

  var precio = "";
  // Buscar el contenedor de tarifa/precio más cercano al formulario
  var $scope = jQuery(form_envio).closest(".card-single, .combo, .card-detail, .wrapper-selects");
  if ($scope.length === 0) {
    $scope = jQuery(form_envio).parent();
  }
  var priceEl = $scope.find('p#item-price-down, .item-price-down').first();
  if (priceEl.length > 0) {
    var precio_html = priceEl.html();
    var partes_precio = precio_html.split(" ");
    precio = partes_precio[0];
  }

  var km = "";
  var meses = "";
  var idcampana_val = "";
  var idcolor_val = "";

  var container = form_envio.closest(".card-single, .combo, .card-detail, .wrapper-selects, .block--inputs");

  if (!container) {
    var parent = form_envio.parentElement;
    container = parent ? parent.querySelector(".wrapper-selects, .block--inputs") : null;
    if (!container) {
      container = parent;
    }
  }

  if (!container) container = document;

  var kmInput = form_envio.querySelector('.kmvar');
  var mesesInput = form_envio.querySelector('.mesesvar');
  var idcampanaInput = form_envio.querySelector('[name="idcampana"], [id^="idcampana"]');
  var idcolorInput = form_envio.querySelector('[name="idcolor"], [id^="idcolor"]');

  if (!kmInput || !kmInput.value) {
    var kmInContainer = container.querySelector('.kmvar');
    if (kmInContainer && kmInContainer.value) kmInput = kmInContainer;
  }
  if (!mesesInput || !mesesInput.value) {
    var mesesInContainer = container.querySelector('.mesesvar');
    if (mesesInContainer && mesesInContainer.value) mesesInput = mesesInContainer;
  }

  if (!kmInput || (!kmInput.value && kmInput.form)) {
    var forms = Array.from(document.querySelectorAll('form.c-form__wrapper'));
    var formIndex = forms.indexOf(form_envio) + 1;
    var kmBySuffix = document.getElementById('km_' + formIndex) || document.getElementById('km' + (formIndex === 1 ? '' : '_' + formIndex));
    if (kmBySuffix) kmInput = kmBySuffix;
  }
  if (!mesesInput || (!mesesInput.value && mesesInput.form)) {
    var forms = Array.from(document.querySelectorAll('form.c-form__wrapper'));
    var formIndex = forms.indexOf(form_envio) + 1;
    var mesesBySuffix = document.getElementById('meses_' + formIndex) || document.getElementById('meses' + (formIndex === 1 ? '' : '_' + formIndex));
    if (mesesBySuffix) mesesInput = mesesBySuffix;
  }

  if (kmInput) km = kmInput.value || "";
  if (mesesInput) meses = mesesInput.value || "";
  if (idcampanaInput) idcampana_val = idcampanaInput.value || "";
  if (idcolorInput) idcolor_val = idcolorInput.value || "";

  if (!km) {
    var selectedKm = container.querySelector('[id^="select-km"] .custom-select__value');
    if (selectedKm) {
      km = selectedKm.textContent.replace(/\D/g, '');
    }
  }
  if (!meses) {
    var selectedMeses = container.querySelector('[id^="select-meses"] .custom-select__value');
    if (selectedMeses) {
      meses = selectedMeses.textContent.replace(/\D/g, '');
    }
  }

  if (!idcolor_val && typeof window.idcolor !== 'undefined' && window.idcolor) {
    idcolor_val = window.idcolor;
  }

  console.log("prepararEnvioF km:", km, "meses:", meses, "idcampana:", idcampana_val, "idcolor:", idcolor_val);

  if (nombre != "" && email != "" && telefono != "") {
    send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, filtro_cliente, comentariosemail, null, km, meses, idcampana_val, idcolor_val);

    var kmSelectedLabel = '';
    if (kmInput) {
      kmSelectedLabel = kmInput.options ? kmInput.options[kmInput.selectedIndex].text.trim() : (km + ' Km');
    }
    var mesesSelectedLabel = '';
    if (mesesInput) {
      mesesSelectedLabel = mesesInput.options ? mesesInput.options[mesesInput.selectedIndex].text.trim() : (meses + ' Meses');
    }

    var km_consultados_arr = Array.from(_km_consultados_set).filter(function (v) {
      return v !== kmSelectedLabel;
    });

    var duracion_consultadas_arr = Array.from(_duracion_consultadas_set).filter(function (v) {
      return v !== mesesSelectedLabel;
    });

    var dlPayload = {
      'event': 'form-id-84',
      'email': email,
      'telefono': telefono,
      'km_seleccionado': kmSelectedLabel,
      'duracion_seleccionada': mesesSelectedLabel
    };

    if (km_consultados_arr.length > 0) {
      dlPayload['km_consultados'] = km_consultados_arr.join(', ');
    }
    if (duracion_consultadas_arr.length > 0) {
      dlPayload['duracion_consultadas'] = duracion_consultadas_arr.join(', ');
    }
    dataLayer.push(dlPayload);

    _km_consultados_set.clear();
    _duracion_consultadas_set.clear();
  }
}

function prepararEnvio2mano(id) {
  var form_envio = document.getElementById("formulario-envio-" + id);
  form_envio.reportValidity();

  var nombre = document.getElementById(id + "your-name").value;
  var email = document.getElementById(id + "your-email").value;
  var telefono = document.getElementById(id + "telefono").value;
  var url_guardada = document.getElementById(id + "url_guardada").value;
  var precio = document.getElementById("precio_modal_" + id).innerHTML;
  var utm_source = document.getElementById(id + "utm_source").value;
  var boletin = "0";
  if (document.getElementById(id + "boletin").checked) {
    boletin = "1";
  }

  var telef = /^\d{9}$/;

  if (telef.test(telefono)) {
    console.log("valor correcto");
  } else {
    console.log("INTRODUCE OTRO VALOR. EJ: +34666555444");
    return false;
  }
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (emailRegex.test(email)) {
    console.log("Correo electrónico válido");
  } else {
    console.log("Correo electrónico inválido");
    return false;
  }
  if (nombre == "") {
    console.log("Nombre inválido");
    return false;
  }


  var id_km = 'km_' + id;
  var e = document.getElementById(id_km);
  var km = e.options[e.selectedIndex].value;

  console.log(" nombre:'" + nombre + "' /email: '" + email + "' /telefono: '" + telefono + "' /precio: " + precio + " /url_guardada: " + url_guardada + " /utm_source: " + utm_source + " /boletin: " + boletin);
  if (nombre != "" && email != "" && telefono != "") {
    send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, "", "", id);
    dataLayer.push({ 'event': 'form-id-84', 'email': email, 'telefono': telefono });
  }

}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////// 
//funcion send2db : envía todos los datos a pooltodb.php para insertar en webcrm (y hace cosas de criteo)
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function send2db(nombre, email, telefono, precio, url_guardada, utm_source, boletin, filtro_cliente, comentariosemail, id_oferta = null, km_param = null, meses_param = null, idcampana_param = null, idcolor_param = null) {
  //console.log("entra en send2db", {nombre, email, telefono, precio, url_guardada, utm_source, boletin, id_oferta, km_param, meses_param, idcampana_param, idcolor_param});

  // --- gettheid (id del producto en WordPress) ---
  var gettheid_element = document.getElementById("gettheid");
  var gettheid = "";
  if (gettheid_element != null) {
    gettheid = gettheid_element.innerHTML;
  } else {
    // segunda mano / instancias con sufijo
    var candidates = ["gettheid_1", "gettheid_2"];
    for (var ci = 0; ci < candidates.length; ci++) {
      var el = document.getElementById(candidates[ci]);
      if (el != null) { gettheid = el.innerHTML; break; }
    }
  }

  if (id_oferta != null) {
    gettheid = id_oferta;
  }

  // --- km ---
  var km = "";
  if (km_param !== null) {
    // Viene directamente de prepararEnvioF (nuevo sistema de selects dinámicos)
    km = km_param;
  } else if (id_oferta != null) {
    // Modal de segunda mano: select nativo con id km_<id_oferta>
    var id_km = 'km_' + id_oferta;
    var e = document.getElementById(id_km);
    if (e) {
      km = e.options ? e.options[e.selectedIndex].value : e.value;
    }
  } else {
    // Fallback: buscar por ID estático (sistema antiguo)
    var km_element = document.getElementById("km");
    if (km_element != null) {
      km = km_element.value;
    }
  }

  // --- meses ---
  var meses = "";
  if (meses_param !== null) {
    meses = meses_param;
  } else if (id_oferta != null) {
    // Modal de segunda mano: duración fija 12 meses
    meses = 12;
  } else {
    var meses_element = document.getElementById("meses");
    if (meses_element != null) {
      meses = meses_element.value;
    }
  }

  // --- idcampana / idcolor ---
  var idcampana = "";
  var idcolor = "";

  if (idcampana_param !== null) {
    idcampana = idcampana_param;
  } else {
    var idcampana_el = document.getElementById("idcampana");
    if (idcampana_el != null) {
      idcampana = idcampana_el.value;
    } else {
      // Intentar con sufijos _1, _2
      for (var si = 1; si <= 2; si++) {
        var ic_el = document.getElementById("idcampana_" + si);
        if (ic_el != null) { idcampana = ic_el.value; break; }
      }
    }
  }

  if (idcolor_param !== null) {
    idcolor = idcolor_param;
  } else {
    var idcolor_el = document.getElementById("idcolor");
    if (idcolor_el != null) {
      idcolor = idcolor_el.value;
    } else {
      for (var si = 1; si <= 2; si++) {
        var icol_el = document.getElementById("idcolor_" + si);
        if (icol_el != null) { idcolor = icol_el.value; break; }
      }
    }
  }

  console.log("send2db -> gettheid:", gettheid, "km:", km, "meses:", meses, "idcampana:", idcampana, "idcolor:", idcolor);


  if (typeof utm_source === 'undefined') {
    var utm_source = "";
  }
  if (url_guardada != "") {
    url_guardada.replace(new RegExp("&", 'g'), ":");
  }

  var pedidodb = new Date().valueOf() + (Math.floor(Math.random() * 100) + 1) + (Math.floor(Math.random() * 100) + 1);

  /*
  sustituir:
  */

  var datastring = 'nombre=' + nombre + "&email=" + email + "&telefono=" + telefono + "&url=" + url_guardada + "&utm_source=" + utm_source + "&idproducto=" + gettheid + "&km=" + km + "&meses=" + meses + "&pedido=" + pedidodb + "&idcampana=" + idcampana + "&idcolor=" + idcolor + "&boletin=" + boletin + "&filtro_cliente=" + filtro_cliente + "&comentariosemail=" + comentariosemail;

  var peticion;

  if (window.XMLHttpRequest) {

    peticion = new XMLHttpRequest();

  } else if (window.ActiveXObject) {

    isIE = true;
    peticion = new ActiveXObject("Microsoft.XMLHTTP");

  }

  peticion.open("POST", "https://rentingfinders.com/pooltodb2_staging.php", true);
  peticion.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=ISO-8859-1');
  //console.log("200 - c");
  //console.log("sending:"+datastring);

  peticion.onerror = function () {
    console.log('Woops, there was an error making the request.');
  };

  peticion.onreadystatechange = function () {
    if (peticion.readyState == 4) {
      if (peticion.status == 200) {
        try {
          var response = JSON.parse(peticion.responseText);
          console.log('R:' + peticion.responseText);
          console.log(response);

          // if (response.status === "ok" && response.accion === "iframe") {

          var urlIframe = response.url_iframe || "";
          nuevo = url_guardada.indexOf("segunda-mano") === -1;
          tipo = url_guardada.indexOf("renting-motos") !== -1 ? "motos" : "vehicle";

          location = 'https://rentingfinders.com/gracias/?id=' + pedidodb + "&idproducto=" + gettheid + "&precio=" + precio + "&nuevo=" + nuevo + "&cliente=" + filtro_cliente + "&bankflip=" + urlIframe + "&tipo=" + tipo;

          //  } else {
          //    console.log("Respuesta no esperada:", response);
          //  }
        } catch (e) {
          console.error("Error al analizar JSON:", e);
          location = 'https://rentingfinders.com/gracias/?id=' + pedidodb + "&idproducto=" + gettheid + "&precio=" + precio;
        }
      } else {
        console.error("Error en la petición. Estado:", peticion.status);
      }
    }
  }

  peticion.send(datastring);

  /*
  //var datastring = 'nombre='+nombre + "&email=" + email + "&telefono=" + telefono + "&url=" + url_guardada + "&utm_source=" + utm_source + "&idproducto=" + gettheid + "&km=" + km + "&meses=" + meses + "&pedido=" + pedidodb +  "&idcampana=" + idcampana +  "&idcolor=" + idcolor+  "&boletin=" + boletin;
  
  
  var jq1124 = jQuery.noConflict();
    data_ob = {
         'nombre'   : nombre,
         'email' : email,
         'telefono'   : telefono ,
         'url'       : url_guardada,
         'utm_source'       : utm_source,
         'idproducto'       : gettheid,
         'km'       : km,
         'meses'    : meses,
         'pedido'    : pedidodb,
         'idcampana'       : idcampana,
         'idcolor'       : idcolor,
         'boletin'       : boletin
         };     
    
    
    var ajaxurl = "https://rentingfinders.com/pooltodb2.php";
     jq1124.ajax({
          type: 'POST',        
          url: ajaxurl,
          data: data_ob,              
          success: function (response) {
            location = 'https://rentingfinders.com/gracias/?id='+pedidodb+"&idproducto="+gettheid+"&precio="+precio;
          }
        });
  
  
  */



}


function validateEmail_cf(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
